module.exports = __webpack_public_path__ + "img/defaultAvatar.2442c4eb.jpg";